document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('[data-mobile-toggle]');
  const nav=document.querySelector('[data-mobile-nav]');
  if(toggle&&nav){toggle.addEventListener('click',()=>{const open=nav.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));});}

  document.querySelectorAll('[data-gallery]').forEach(gallery=>{
    const main=gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(button=>{
      button.addEventListener('click',()=>{
        const template=button.querySelector('template');
        if(template&&main){main.innerHTML=template.innerHTML;}
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(b=>b.setAttribute('aria-current','false'));
        button.setAttribute('aria-current','true');
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(form=>{
    const select=form.querySelector('[name="id"]');
    const price=form.querySelector('[data-variant-price]');
    const button=form.querySelector('[type="submit"]');
    if(!select)return;
    select.addEventListener('change',()=>{
      const option=select.options[select.selectedIndex];
      if(price&&option.dataset.price)price.textContent=option.dataset.price;
      if(button){const available=option.dataset.available==='true';button.disabled=!available;button.textContent=available?'Add to cart':'Sold out';}
    });
  });
});
